import React, { useState } from "react";
import DashboardTable from "../dashboard/DashboardTable";
import { GetInvoiceColumns } from "./invoiceColumns";
import { getInvoices } from "../../services/invoiceService";

export default function InvoicesTable({ accountNumber }) {
  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const handleMultiSelect = (item) => {
    setSelectedInvoices((invoices) => {
      const invoiceInList = invoices.find((i) => i === item.invoiceNumber);
      if (invoiceInList) {
        return invoices.filter((i) => i !== item.invoiceNumber);
      } else {
        return [...invoices, item.invoiceNumber];
      }
    });
  };

  const invoiceColumns = React.useMemo(
    () => GetInvoiceColumns(handleMultiSelect),
    []
  );

  if (!accountNumber) {
    return (
      <h3>
        You must select an account that you have access to from the main screen
      </h3>
    );
  }

  return (
    <DashboardTable
      accountNumber={accountNumber}
      title={"Invoices"}
      columns={invoiceColumns}
      getData={getInvoices}
      color={"info"}
      invoices={selectedInvoices}
    />
  );
}